module.exports = __webpack_public_path__ + "img/06_no.4149842a.svg";